<!-- Footer Component -->

<template>
	<div class="footer-main">
		<BannerAdMess />
		<div class="spacer" />
		<!-- <UniBanner /> -->
		<BannerDA />
	</div>
</template>

<script>
import BannerAdMess from '@/components/BannerAdMess.vue';
import BannerDA from '@/components/BannerDA.vue';
export default {
	components: {
		BannerAdMess,
		BannerDA,
	}
}
</script>

<style scoped>
.footer-main {
	height: 100%;
	overflow: hidden;
	border-radius: 5px;
	border: solid 0px #06F;
}
.spacer {
	display: inline-block;
	height: 10px;
	width: 5px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #C30;	
}
</style>
